module.exports = __webpack_public_path__ + "static/media/sc_1.8523972c.jpg";